import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const HeaderContainer = styled.header`
  background-color: var(--secondary-color);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.div`
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  
  &::before, &::after {
    content: '';
    display: block;
    width: 4px;
    height: 20px;
    background-color: var(--secondary-color);
    margin: 0 2px;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
`;

const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  margin-left: 2rem;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const PrimaryButton = styled(Link)`
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s;
  margin-left: 1rem;
  
  &:hover {
    background-color: #d67559;
  }
`;

const SecondaryButton = styled(Link)`
  display: inline-block;
  background-color: white;
  color: var(--primary-color);
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s;
  margin-left: 1rem;
  
  &:hover {
    background-color: #f8f8f8;
  }
`;

const Header = () => {
  const { isAuthenticated, user } = useAuth();

  return (
    <HeaderContainer>
      <Logo>
        <LogoImage />
      </Logo>
      
      <Nav>
        <NavLink to="/">Inicio</NavLink>
        
        {isAuthenticated ? (
          <>
            <NavLink to="/profile">Mi Perfil</NavLink>
            <NavLink to="/offers">Mis Ofertas</NavLink>
            <PrimaryButton to="/nueva-oferta">Nueva Oferta</PrimaryButton>
          </>
        ) : (
          <>
            <NavLink to="/">Servicios</NavLink>
            <NavLink to="/">Ayuda</NavLink>
            <SecondaryButton to="/login">Iniciar Sesión</SecondaryButton>
            <PrimaryButton to="/register">Registrarse</PrimaryButton>
          </>
        )}
      </Nav>
    </HeaderContainer>
  );
};

export default Header; 